import React from "react";
import { createTheme, ThemeOptions } from "@material-ui/core/styles";
import { ThemeProvider } from "@material-ui/core";
import demo from "./themes/demo.json";

const Theme = (props: React.PropsWithChildren<{ obj?: any }>) => {
  const themeObj = React.useMemo(() => {
    if (process.env.NODE_ENV === "development") {
      let strData = props.obj
        ? JSON.stringify(props.obj)
        : JSON.stringify(demo || null);
      strData = strData
        .split("url(")
        .join(`url(${process.env.REACT_APP_SERVER_URL}`);
      return createTheme(JSON.parse(strData));
    }
    return createTheme((props.obj || demo) as any);
  }, []);
  return <ThemeProvider theme={themeObj}>{props.children}</ThemeProvider>;
};

export default Theme;
